import React, { Component } from "react";

import TextField          from "material-ui/TextField";
import FlatButton         from "material-ui/FlatButton";
import Paper              from "material-ui/Paper";
import Dialog             from 'material-ui/Dialog';
import RaisedButton       from "material-ui/RaisedButton";
import { Grid, Row, Col } from 'react-material-responsive-grid';
import '../CSS/style_Login.css';

import { login } from '../Actions/Action_Authentication.js';
import { recoverCredentials } from '../Actions/Action_ServiceRequest_RecuperaCredenziali';
import { LABEL_Cancel, LABEL_Send, LABEL_Login, LABEL_ForgotPassword, LABEL_DIALOG_CONTENT_RecoverPassword, LABEL_PasswordRecovery,
         LABEL_Password, LABEL_SignIn, LABEL_Email, LABEL_Enter_Email, LABEL_Enter_Password, LABEL_Username, LABEL_Enter_Username, LABEL_ChooseVersione } from "../Utils/Strings/Labels";
import * as PAGESSWITCH from "../Utils/PagesSwitch.js";
//STRINGS
import * as ROUTE from "../Utils/Strings/Route";

const styles = {
  filterDialog : {
    width    : '100%',
    maxWidth : 'none'
  }
};

class LoginForms extends Component {

  constructor(props) {
    super(props);
    
		this.state = {
      username : "",
      password : "",
      recoverDialog: {
        visible : false,
        Email   : "",
        msgErrorEmail: ""
      }
    };
  }
  
  onTextChange = (event, name) => this.setState( {[name]: event.target.value} );

  handleRecoverDialogShow = (visible = false) =>{
    var recoverDialog     = this.state.recoverDialog;
    recoverDialog.visible = visible;
    if(visible == true)
      recoverDialog.msgErrorEmail = "";
    this.setState({recoverDialog:recoverDialog});
  };

  handleRecoverTextChange = (event, text) =>{
    var recoverDialog     = this.state.recoverDialog;
    recoverDialog[text]   = event.target.value;
    if(recoverDialog[text] == "")
      recoverDialog["msgError"+text] = "Obbligatorio";
    this.setState({recoverDialog:recoverDialog});
  }

  handleSendEmailRecoverDialog = () => {
    var recoverDialog     = this.state.recoverDialog;
    if(recoverDialog.Email == ""){
      recoverDialog.msgErrorEmail = "Obbligatorio";
    }else{
      this.props.dispatch(recoverCredentials(recoverDialog.Email));
    }
    this.setState({recoverDialog:recoverDialog});
  }

  render() {

    const recoverDialogAction = [
      <RaisedButton
        label={LABEL_Cancel}
        primary={false}
        onClick={() => this.handleRecoverDialogShow(false)}
      />,
      <RaisedButton
        label={LABEL_Send}
        primary={true}
        onClick={this.handleSendEmailRecoverDialog}
      />
    ];

    return <div>
              <div className="row login-container">
                <div className="page">
                  <Paper zDepth={2} className="login">
                    <form onSubmit={event => this.handleClick(event)}>

                      <section>
                        <TextField className="input-label"
                          onChange={event => this.onTextChange(event, 'username')}
                          hintText={LABEL_Enter_Username}
                          floatingLabelText={LABEL_Username}
                          errorText={this.props.usernameError} />
                      </section>
                      
                      <section>
                        <TextField 
                          className="input-label"
                          type="password"
                          onChange={event => this.onTextChange(event, 'password')}
                          hintText={LABEL_Enter_Password}
                          floatingLabelText={LABEL_Password}
                          errorText={this.props.passwordError}/>
                      </section>
                        
                        {this.props.error && <p style={{color: "red", textAlign: "center"}}>{this.props.error}</p>}

                      <section>
                        <button className="btn-login" type="submit" >{LABEL_Login}</button>
                      </section>
                    
                    </form>
                    
                    <div className="footer-container">
                      <section>
                        <FlatButton
                          className="btn-bottom-first"
                          label={LABEL_ForgotPassword}
                          onClick={() => this.handleRecoverDialogShow(true)} />
                        <FlatButton
                          className="btn-bottom"
                          label={LABEL_ChooseVersione}
                          onClick={() => PAGESSWITCH.gotoPageWithParams(ROUTE.ChooseVersion) } />
                        <FlatButton
                          className="btn-bottom"
                          label={LABEL_SignIn}
                          onClick={() => PAGESSWITCH.gotoPageWithParams(ROUTE.SignIn) } />
                      </section>
                    </div>
                  </Paper>
                </div>
              </div>

              <Dialog
                title={LABEL_PasswordRecovery}
                actions={recoverDialogAction}
                modal={true}
                contentStyle={styles.filterDialog}
                open={this.state.recoverDialog.visible}
              >
              <p>{LABEL_DIALOG_CONTENT_RecoverPassword}</p>
                <Grid>
                  <Row>
                    <Col xs4={1}></Col>
                    <Col xs4={2}>
                      <TextField className="input-label"
                          onChange={event => this.handleRecoverTextChange(event, 'Email')}
                          hintText={LABEL_Enter_Email}
                          floatingLabelText={LABEL_Email}
                          errorText={this.state.recoverDialog.msgErrorEmail}
                          fullWidth={true} />
                    </Col>
                    <Col xs4={1}></Col>
                  </Row>
                </Grid>
              </Dialog>
        </div>;
  }

  handleClick(event) {
    if (typeof event !== "undefined")
      event.preventDefault();
    
    const creds = {
      username: this.state.username.trim(),
      password: this.state.password.trim()
    };

    this.props.dispatch(login(creds));
  }
}

export default LoginForms;


// WEBPACK FOOTER //
// ./src/Components/component_LoginForm.js